/**
 * CryptoCommand — Sprint 21.7.2 Domain Command Center.
 * Specialist home for crypto. Binance holdings + on-chain signals.
 */
import { useEffect } from 'react';
import { Bitcoin } from 'lucide-react';
import CommandCenterLayout from '../../components/CommandCenter/CommandCenterLayout.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function CryptoCommand() {
  const { setPage } = usePage();
  useEffect(() => { setPage('command-crypto'); }, []);
  return (
    <CommandCenterLayout
      domain="crypto"
      title="Crypto Command"
      icon={<Bitcoin className="w-5 h-5" />}
      subtitle="Bitcoin · majors · RWA tokenization · on-chain flows"
    />
  );
}
